import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cxInvoicing')
  .controller('MailHistoryDialogCtrl', [
    '$element',
    '$window',
    'reminderHttpSvc',
    'close',
    'invoice',
    '$http',
    'appUrls',
    'flySvc',
    'dataCache',
    mailHistoryDialogCtrl,
  ]);

function mailHistoryDialogCtrl(
  $element,
  $window,
  reminderHttpSvc,
  close,
  invoice,
  $http,
  appUrls,
  flySvc,
  dataCache,
) {
  var vm = this;
  vm.invoice = invoice;
  vm.data = null;
  vm.sentDate = vm.invoice.sentOn;
  vm.sentUser = null;
  vm.showCc = false;
  vm.showBcc = false;

  dataCache.ready().then(function() {
    vm.sentUser = dataCache.getArray('user').find(function(user) {
      return user.userID === vm.invoice.sentBy;
    });
  });

  vm.openInvoiceAuditDialog = () => {
    close(true, 500);
  };

  var getEmails = function() {
    $http
      .get(appUrls.documents + '/api/emails/InvoiceHistory/' + invoice.id)
      .then(function(response) {
        var result = response.data;
        if (!vm.data) vm.data = [];
        if (result && result.length > 0) {
          vm.showCc = result.some(x => x.cc.length > 0);
          vm.showBcc = result.some(x => x.bcc.length > 0);
          result.forEach(function(email) {
            vm.data.push(email);
          });
        }
      });
  };
  getEmails();

  vm.previewMail = function(html, subject) {
    var preview = $window.open(
      '',
      'MailPreviewWindow',
      'location=0,menubar=0,titlebar=0,toolbar=0',
    );
    preview.document.write(html);
    preview.document.title = subject;
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.downloadAttachment = attachment => DocumentService.download(attachment.id);
}
